import { EventCategory } from "healthex-common/analytics.dtos";
export const AnalyticsEvents = {
    HEAP_LOAD_ATTEMPTED: "HEAP_LOAD_ATTEMPTED",
    HEAP_LOAD_TIMEOUT: "HEAP_LOAD_TIMEOUT",
    HEAP_LOADED: "HEAP_LOADED",
    HEAP_LOAD_ERROR: "HEAP_LOAD_ERROR",
};
export function trackAnalyticsEvent(action, extraMetadata) {
    var _a;
    const apiBaseUrl = (_a = window.ENVIRONMENT) === null || _a === void 0 ? void 0 : _a.API_BASE_URL;
    if (!apiBaseUrl) {
        console.warn("Cannot track public event: API_BASE_URL not available");
        return;
    }
    void fetch(`${apiBaseUrl}/analytics/event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            category: EventCategory.SCREEN,
            action,
            metadata: {
                url: window.location.href,
                userAgent: navigator.userAgent,
                ...extraMetadata,
            },
        }),
    }).catch((error) => console.error("Failed to track public event: ", error));
}
